import TOGGLE_LOADING from "./constants";

export default function toggleLoading(bool) {
  return {
    type: TOGGLE_LOADING,
    payload: bool,
  };
}
